import React, { useEffect } from 'react'
import { ChatBotStyles } from 'components/common/Chatbot/Chatbot.styles'

const ChatBot = () => {
  useEffect(() => {
    const scriptConfig = document.createElement('script')
    scriptConfig.innerHTML = `
        window.embeddedChatbotConfig = {
          chatbotId: "voFf9vwgWEAbA3WWBsDTq",
          domain: "www.chatbase.co",
          showFooter: false
        };
      `
    document.body.appendChild(scriptConfig)

    const script = document.createElement('script')
    script.src = 'https://www.chatbase.co/embed.min.js'
    script.setAttribute('chatbotId', 'voFf9vwgWEAbA3WWBsDTq')
    script.setAttribute('domain', 'www.chatbase.co')
    script.defer = true
    script.id = 'chatbase-script' // Assign an ID for easier management
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(scriptConfig)
      const existingScript = document.getElementById('chatbase-script')
      const chatBaseButton = document.getElementById('chatbase-bubble-button')
      if (existingScript) {
        document.body.removeChild(existingScript)
      }

      if (chatBaseButton) {
        document.body.removeChild(chatBaseButton)
      }
    }
  }, [])

  return <ChatBotStyles />
}

export default ChatBot
